import {useReleaseNotesHook} from "./ReleaseNotesHook";
import {ReleaseNoteCard} from "./ReleaseNoteCard";


export function ReleaseNotes() {
    const { releaseNotes, awaitingResponse } = useReleaseNotesHook({});
        
    return (
        <>
            { !awaitingResponse &&
                releaseNotes?.map(releaseNote => (
                    <ReleaseNoteCard
                        key={ releaseNote.version }
                        version={ releaseNote.version }    
                        title={ releaseNote.title ?? "Release " + releaseNote.version }
                        message={ releaseNote.message }
                        date={ releaseNote.timestampUtc }
                    />
                ))
            }
        </>
    );
}
